import React from "react";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

const FileIcon = ({ fileName, fileUrl }) => {
  const fileExtension = React.useMemo(() => {
    return fileUrl?.split(".")?.pop() ?? "";
  }, [fileUrl]);

  const fileColorClass = React.useMemo(() => {
    switch (fileExtension.toUpperCase()) {
      case "PDF":
        return "text-red-400";

      case "JPG":
      case "JPEG":
      case "PNG":
        return "text-yellow-400";

      default:
        return "text-slate-400";
    }
  }, [fileExtension]);

  return (
    <div title={`View ${fileName ?? "file"}`} className="inline-block ">
      <div className="relative mt-2 overflow-hidden">
        <InsertDriveFileOutlinedIcon
          className={` ${fileColorClass}`}
          style={{ fontSize: 50 }}
        />

        <div className="absolute top-1/2 left-1/2 -translate-x-1/2  transform text-[6px] font-bold uppercase tracking-wider text-slate-600">
          {fileExtension}
        </div>
      </div>

      {!!fileName && (
        <div className="flex-wrap text-xs line-clamp-2">{fileName}</div>
      )}
    </div>
  );
};

export default FileIcon;
